import type {Offer} from '@yandex-delivery/api/model/offer'
import {useTransition} from '@yandex-delivery/blocks'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {useFormContext} from '@yandex-delivery/form'
import {useRefresh} from '@yandex-delivery/hooks'

import type {FetchOffersCalculateReturnType} from '../api'
import {fetchOffersCalculate} from '../api'
import type {Props} from './types'

const setFieldValueParams = {
  shouldTouch: false,
  shouldDirty: false,
  shouldValidate: false,
}

export function useOffers(props: Required<Props>) {
  const {name, body} = props
  const {resetField, setFieldValue, getFieldErrors, watch} = useFormContext()
  const [, startTransition] = useTransition<FetchOffersCalculateReturnType, ServerError>(undefined, {
    key: `fetch/offers-${name}`,
  })

  // TODO пока что я не успел сделать стейт. Поэтому тут я явно использую название поля
  const selectedVertical: string | undefined = watch('offerFlow.vertical.name')

  const [{payload, isPending}] = useTransition<FetchOffersCalculateReturnType, ServerError>(
    async function _fetchOffersCalculate() {
      try {
        // TODO пока что я не успел сделать стейт. Поэтому тут я явно использую название поля
        setFieldValue('offerFlow.isPending', true, setFieldValueParams)

        return await fetchOffersCalculate({
          startTransition,
          selectedVertical,
          body,
          onCommit(returnType) {
            // TODO пока что логика сброса живет здесь. По уму она должна быть в компоненте OffersList
            if (returnType.response.length === 0) {
              resetField(name)
            }
          },
          onError() {
            resetField(name)
          },
        })
      } finally {
        // TODO пока что я не успел сделать стейт. Поэтому тут я явно использую название поля
        setFieldValue('offerFlow.isPending', false, setFieldValueParams)
      }
    },
    {key: `fetch/offers-${name}`},
  )

  const isValid = getFieldErrors(name) === undefined

  const {pollFunction, response = DEFAULT_OFFERS} = payload || {}

  useRefresh(pollFunction, {interval: REFRESH_TIMEOUT})

  return {
    isPending,
    isValid,
    name,
    offers: response,
  } as const
}

// 2 минуты
const REFRESH_TIMEOUT = 1000 * 60 * 2
const DEFAULT_OFFERS: Array<Offer> = []
